import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { getCookieConsent } from "@/utils/cookieConsent";

const GoogleAnalyticsTracker = () => {
  const location = useLocation();
  const [isInitialized, setIsInitialized] = useState(false);

  // Ne plus initialiser automatiquement GA4
  // L'initialisation se fera uniquement après consentement
  useEffect(() => {
    const consent = getCookieConsent();
    const measurementId = "G-R06X5KHHPN";

    if (consent?.analytics && !isInitialized) {
      ReactGA.initialize(measurementId, {
        gtagOptions: {
          anonymize_ip: true,
          send_page_view: false,
        }
      });
      setIsInitialized(true);
      console.log("✅ Google Analytics initialisé avec consentement");
    }
  }, [isInitialized]);

  // Écouter les changements de consentement
  useEffect(() => {
    const handleConsentUpdate = (event: CustomEvent) => {
      const preferences = event.detail;
      
      if (preferences.analytics && !isInitialized) {
        const measurementId = "G-R06X5KHHPN";
        ReactGA.initialize(measurementId, {
          gtagOptions: {
            anonymize_ip: true,
            send_page_view: false,
          }
        });
        setIsInitialized(true);
        console.log("✅ Google Analytics activé suite au consentement");
      }
    };

    window.addEventListener('cookieConsentUpdated', handleConsentUpdate as EventListener);
    
    return () => {
      window.removeEventListener('cookieConsentUpdated', handleConsentUpdate as EventListener);
    };
  }, [isInitialized]);

  // Tracking des pages uniquement si GA4 est initialisé
  useEffect(() => {
    if (isInitialized) {
      ReactGA.send({ 
        hitType: "pageview", 
        page: location.pathname + location.search 
      });
      console.log("📊 Page vue:", location.pathname);
    }
  }, [location, isInitialized]);

  return null;
};

export default GoogleAnalyticsTracker;
